<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <component id="carbooked-chart-header" v-if="!timeout" :is="chartType + 'Chart'" :chartId="chartId"
        :data="chartData" :options="chartOptions"></component>
      <div v-if="timeout" class="text-center">
        <i class="fa fa-refresh fa-5x text-danger" aria-hidden="true"></i>
        <p>{{ name }}</p>
        <p class="text-muted">
          Sorry, we've been unable to refresh the chart data whilst the feed is
          updating, we will try again soon.
        </p>
      </div>
      <!-- <b-tooltip target="carbooked-chart-header" triggers="hover"
        >A line bar that shows spend against commitment picked up across various
        events. Hover over a bar segment to see slac breakdown more.</b-tooltip
      > -->
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import randomColor from "randomcolor";
import moment from "moment";

import DonutChart from "@/pages/private/charts/Donut-chart";
import shortid from "shortid";

export default {
  name: "OrderPie",
  props: ["tile", "refresh"],
  components: {
    DonutChart,
  },
  data() {
    return {
      busy: false,
      timeout: false,
      name: "Order Pie",
      chartId: shortid.generate(),
      defaultOptions: {
        palette: [
          {
            name: "remaining",
            backgroundColor: "rgba(46,184,92,0.1)",
            borderColor: "#2eb85c",
            pointHoverBackgroundColor: "#2eb85c",
            borderWidth: 2,
          },
          {
            name: "credit",
            backgroundColor: "rgba(71,153,235,0.1)",
            borderColor: "#6c757d",
            pointHoverBackgroundColor: "#549c60",
            borderWidth: 2,
          },
          {
            name: "invoice",
            backgroundColor: "rgba(249,177,21,0.1)",
            borderColor: "#f9b115",
            pointHoverBackgroundColor: "#f9b115",
            borderWidth: 2,
          },
          {
            name: "overspent",
            backgroundColor: "rgba(229,83,83,0.1)",
            borderColor: "#e55353",
            pointHoverBackgroundColor: "#e55353",
            borderWidth: 2,
          },
          {
            name: "reclaim",
            backgroundColor: "rgba(32, 168, 216, 0.1)",
            borderColor: "#20a8d8",
            pointHoverBackgroundColor: "#20a8d8",
            borderWidth: 2
          },

          // {
          //   name: "remaining",
          //   backgroundColor: "rgba(249,177,21,0.1)",
          //   borderColor: "#f9b115",
          //   pointHoverBackgroundColor: "#f9b115",
          //   borderWidth: 2,
          // },
          // {
          //   name: "invoice",
          //   backgroundColor: "rgba(46,184,92,0.1)",
          //   borderColor: "#2eb85c",
          //   pointHoverBackgroundColor: "#2eb85c",
          //   borderWidth: 2,
          // },
          // {
          //   name: "credit",
          //   backgroundColor: "rgba(229,83,83,0.1)",
          //   borderColor: "#e55353",
          //   pointHoverBackgroundColor: "#e55353",
          //   borderWidth: 2,
          // },
          // {
          //   name: "overspent",
          //   // backgroundColor: "rgba(249,177,21,0.1)",
          //   // borderColor: "#f9b115",
          //   backgroundColor: "rgba(71,153,235,0.1)",
          //   borderColor: "#6c757d",
          //   pointHoverBackgroundColor: "#549c60",
          //   borderWidth: 2,
          // },

        ],
        donut: {
          responsive: true,
          maintainAspectRatio: true,
          datalabels: {
            display: false,
          },
          hole: {
            display: true,
            text: "OK",
          },
          title: {
            display: true,
            text: "Order Chart",
          },
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 10,
              display: true,
              fontSize: 10,
            },
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var total = dataset.data.reduce(function (
                  previousValue,
                  currentValue,
                  currentIndex,
                  array
                ) {
                  return previousValue + currentValue;
                });
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = currentValue; //parseFloat((currentValue / total) * 100 + 0.5).toFixed(2);

                let raw = dataset.raw[tooltipItem.index];
                return raw.key + " : " + raw.value;
                // return percentage + "%";
              },
              //   afterLabel: function(tooltipItem, data) {
              //     let raw =
              //       data.datasets[tooltipItem.datasetIndex].raw[
              //         tooltipItem.index
              //       ];
              //     // console.log(raw);
              //     return [
              //       "Name: " + raw.key,
              //       "Value: " + raw.value,
              //     ];
              //   }
            },
          },
          onClick: function (evt, item) {
            var activePoints = this.getElementsAtEvent(evt);
            var firstPoint = activePoints[0];
            console.log("donut click", evt, item, activePoints, firstPoint);
          },
        },
      },
      chartData: null,
      chartOptions: null,
      chartEvents: null,
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    ...mapGetters(["palette", "user"]),
    chartType() {
      if (!this.tile.settings) {
        return "donut";
      }
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "donut";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: OrderPie");
      if (!this.tile.settings) return;

      let setting = null;
      this.busy = true;

      try {
        let values = this.tile.data.datasets[0].data;
        console.log(values);
        let total = values.reduce(function (
          previousValue,
          currentValue,
          currentIndex,
          array
        ) {
          return previousValue + currentValue;
        });
        let newvalues = [];
        for (var i = 0; i < values.length; i++) {
          var currentValue = values[i];
          var percentage = parseFloat(
            (currentValue / total) * 100 //+ 0.5
          ).toFixed(2);
          newvalues.push(percentage);
        }

        this.chartData = {
          labels: this.tile.data.labels,
          datasets: [
            {
              backgroundColor: [],
              data: newvalues,
              raw: this.tile.data.raw,
            },
          ],
        };

        //FIND THE DATE AND PUSH THE COLOUR
        for (var i = 0; i < this.tile.data.raw.length; i++) {
          let colour = this.defaultOptions.palette.find(
            (o) => o.name == "remaining"
          );

          let item = this.tile.data.raw[i];
          switch (item.key.toLowerCase()) {
            case "reclaim":
            case "remaining":
            case "overspent":
              colour = this.defaultOptions.palette.find(
                (o) => o.name == item.key.toLowerCase()
              );
              console.log('looking for', item.key.toLowerCase(), colour.borderColor)
              break;
            default:
              if (parseInt(item.value) > 0) {
                colour = this.defaultOptions.palette.find(
                  (o) => o.name == "invoice"
                );
              } else if (parseInt(item.value) < 0) {
                colour = this.defaultOptions.palette.find(
                  (o) => o.name == "credit"
                );
              }
          }

          this.chartData.datasets[0].backgroundColor.push(colour.borderColor);
        }

        // GET THE DEFAULT OPTIONS FOR THE CHART TYPE
        this.chartOptions = this.defaultOptions[this.chartType];
        let setting = null;

        setting = this.tile.settings.find((o) => o.key == "title");
        if (setting.value) {
          this.chartOptions.title = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "titletext");
          if (setting) {
            // REPLACE LATER WITH FORMATTED
            let titletext = setting.value;
            this.chartOptions.title.text = titletext;
          }
        } else {
          this.chartOptions.title = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "holetext");
        if (setting) {
          // REPLACE LATER WITH FORMATTED
          this.chartOptions.hole.text = setting.value;
        }

        setting = this.tile.settings.find((o) => o.key == "legend");
        if (setting.value) {
          this.chartOptions.legend = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "legendposition");
          if (setting) {
            this.chartOptions.legend.position = setting.value;
          }
          this.chartOptions.legend.labels = { boxWidth: 12 };
        } else {
          this.chartOptions.legend = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "datalabels");
        if (setting.value) {
          this.chartOptions.datalabels = {
            display: true,
          };
        } else {
          this.chartOptions.datalabels = {
            display: false,
          };

        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      await this.loadChart();
    },
  },
};
</script>

<style></style>